/**
 * The form-level error banner.
 *
 * Small, and it exists as its own component for what it owns rather than for its size: the
 * `role="alert"` that makes a failure arriving after submission actually reach a screen reader, and
 * the icon-plus-text composition that must not turn into a bare coloured div at the next call site.
 * A screen reads `<FormBanner message={…} />` and knows what it is; a div with a triangle in it says
 * nothing.
 */

import { WarningIcon } from './AuthIcons';
import styles from './FormBanner.module.css';

interface FormBannerProps {
  /** Nothing renders when this is null — the caller does not need to branch. */
  message: string | null;
}

export function FormBanner({ message }: FormBannerProps) {
  if (message === null || message === '') return null;

  return (
    // `role="alert"` rather than a polite live region: this message is the answer to something the
    // trainer just did, and it has to interrupt.
    <div className={styles.banner} role="alert">
      <WarningIcon className={styles.icon} />
      <span className={styles.text}>{message}</span>
    </div>
  );
}
